module.exports = __webpack_public_path__ + "static/media/default-image.2ff08c69.png";